module.exports = __webpack_public_path__ + "static/media/main idea.5e2facc1.mp3";